import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureForecastBillApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/billing-forecast" : "next_month_forecast";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};

export const getAzureResourceGroupForecastBillApi = async (resourceGroupSearchJson, provider) => {
  try {
    resourceGroupSearchJson.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/billing-forecast" : "resourcebybilling";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      params: resourceGroupSearchJson.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};

export const getAzureDailyForecastBillApi = async (dailySearchJson, provider) => {
  try {
    dailySearchJson.params.type = 1; // Assuming you want to set the type here
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/billing-forecast" : "date_forecast_weekly_monthly";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      params: dailySearchJson.params, // Send dailySearchJson as query parameters
    });
    return response;
  } catch (e) {
    console.error("Error fetching daily forecast bill:", e);
    return [];
  }
};

export const getAzureLocationForecastBillApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/billing-forecast" : "azure_location";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};
